(() => {
  let observer;
  let scheduled = false;

  const findFixedAncestor = (element) => {
    let node = element;
    for (let level = 0; node && level < 7; level += 1, node = node.parentElement) {
      if (window.getComputedStyle(node).position === 'fixed') return node;
    }
    return null;
  };

  const hideFixedWithdrawalControl = () => {
    scheduled = false;

    const candidates = document.querySelectorAll(
      'a[href*="widerruf" i], button, [role="button"], [class*="widerruf" i], [id*="widerruf" i]'
    );

    for (const element of candidates) {
      const text = (element.textContent || '').trim().toLowerCase();
      const href = element.getAttribute ? (element.getAttribute('href') || '').toLowerCase() : '';
      const marker = `${element.id || ''} ${element.className || ''}`.toLowerCase();

      const looksLikeWithdrawalControl =
        text.includes('widerruf') ||
        href.includes('widerruf') ||
        marker.includes('widerruf');

      if (!looksLikeWithdrawalControl) continue;

      const fixedContainer = findFixedAncestor(element);
      if (fixedContainer) {
        fixedContainer.style.setProperty('display', 'none', 'important');
        fixedContainer.setAttribute('aria-hidden', 'true');
        if (observer) observer.disconnect();
        return true;
      }
    }

    return false;
  };

  const scheduleScan = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(hideFixedWithdrawalControl);
  };

  const init = () => {
    if (hideFixedWithdrawalControl()) return;

    observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, { childList: true, subtree: true });

    // Stop observing after app embeds have had enough time to load.
    window.setTimeout(() => {
      if (observer) observer.disconnect();
    }, 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
